import {useIntl} from 'react-intl';
import React from 'react';
import {
  Table
} from 'react-lib/frameworks/Table'

const ReExaminationUX = (props: any) => {
    const intl = useIntl();
    const isMounted = React.useRef(true);

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{ width: "100%", height: "100%", padding: "5px" }}>
        <div
          style={{ padding: "5px",   color: "black", fontWeight: "bold", fontSize: "1.5em"}}>
          {intl.formatMessage({id: "cukey176"})}
        </div>
        <div
          style={{ display: "flex", height: "100%", padding: "10px" }}>
          <Table
            columns={props.columnsReExamination}
            data={props.encounterMedical}
            defaultPageSize="10"
            pageSize="10"
            showPagination={false}
            style={{height:"500px", width:"100%"}}>
          </Table>
        </div>
      </div>
    )
}

export default ReExaminationUX

export const screenPropsDefault = {}

/* Date Time : Thu May 27 2021 02:31:33 GMT+0000 (Coordinated Universal Time)
/* Original screen Data **************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"5px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey176"})}
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\",   color: \"black\", fontWeight: \"bold\", fontSize: \"1.5em\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", height: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 2,
      "props": {
        "columns": {
          "type": "code",
          "value": "props.columnsReExamination"
        },
        "data": {
          "type": "code",
          "value": "props.encounterMedical"
        },
        "defaultPageSize": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"500px\", width:\"100%\"}"
        }
      },
      "seq": 3,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": true,
  "memo": false,
  "name": "ReExaminationUX",
  "project": "cudent",
  "screenPropsDefault": {
  },
  "width": 55
}

************************************************************************************* */
